import React, { useContext } from 'react';
import FieldContext from '../../FieldContext';
import StyledFieldName from './StyledFieldName';
import NoFieldName from './NoFieldName';
import { FormattedMessage } from 'react-intl';
import EditorIsReadonlyContext from '@/pages/EditorPage/ChallengeModelsEditor/EditorIsReadonlyContext';

type FieldNameProps = {
  onClick: (event: React.MouseEvent<HTMLHeadingElement, MouseEvent>) => void;
};

const FieldName = ({ onClick }: FieldNameProps) => {
  const { field } = useContext(FieldContext);
  const editorIsReadonly = useContext(EditorIsReadonlyContext);

  return (
    <StyledFieldName
      onClick={editorIsReadonly ? undefined : onClick}
      disabled={editorIsReadonly}
    >
      {field!.name ?? (
        <NoFieldName>
          <FormattedMessage id="editor.model_editor.field_editor.no_name" />
        </NoFieldName>
      )}
    </StyledFieldName>
  );
};

export default FieldName;
